module.exports = __webpack_public_path__ + "static/media/clone.251a4166.svg";